import { render, staticRenderFns } from "./KeenUiSelect.vue?vue&type=template&id=3851fa15&scoped=true&"
import script from "./KeenUiSelect.vue?vue&type=script&lang=js&"
export * from "./KeenUiSelect.vue?vue&type=script&lang=js&"
import style0 from "./KeenUiSelect.vue?vue&type=style&index=0&id=3851fa15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3851fa15",
  null
  
)

export default component.exports